import { ComponentProps, ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Logo from '@alltrails/denali/components/Logo';
import AltLoginsForm from '../AltLoginsForm';
import SectionDivider from '../SectionDivider';
import TermsOfService from '../TermsOfService';
import styles from './SignUpModal.module.scss';

type InitialProps = Pick<ComponentProps<typeof AltLoginsForm>, 'appleLoginHandler' | 'facebookLoginHandler' | 'googleLoginHandler'> & {
  heading?: ReactNode;
  onCreateAccountClick: () => void;
  onLogInClick: () => void;
};

// Desktop: https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=251%3A16532
// Mobile: https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=250%3A16053

const Initial = ({ heading, onCreateAccountClick, onLogInClick, ...loginHandlers }: InitialProps) => {
  return (
    <div className={styles.content}>
      <div className={styles.logo}>
        <Logo color="monochrome-dark" size="lg" variant="symbol" />
      </div>
      <Typography className={styles.heading} component="div" variant="heading400">
        {heading || <FormattedMessage defaultMessage="To keep exploring trails, log in or sign up for free" />}
      </Typography>
      <AltLoginsForm {...loginHandlers} authType="signup" />
      <SectionDivider classes={styles.divider}>
        <FormattedMessage defaultMessage="or" />
      </SectionDivider>
      <div className={styles.signUpLogInContainer}>
        <Button
          text={<FormattedMessage defaultMessage="Create a free account" />}
          onClick={onCreateAccountClick}
          testId="initial-sign-up-screen-create-account"
          variant="primary"
          width="full"
        />
      </div>
      <div className={styles.signUpLogInContainer}>
        <Typography className={styles.inline} color="secondary" component="div" variant="text200">
          <FormattedMessage defaultMessage="Already have an account?" />{' '}
        </Typography>
        <Link size="md" testId="sign-up-log-in-nav" onClick={onLogInClick}>
          <FormattedMessage defaultMessage="Log in" />
        </Link>
      </div>
      <TermsOfService />
    </div>
  );
};

export default Initial;
